import React, { useRef } from "react";
export const AsyncExecutorPoolContext = React.createContext({
  getExecutor: () => {},
  addExecutor: (key, executor) => {}
});
export const useAsyncExecutorPool = key => {
  return React.useContext(AsyncExecutorPoolContext);
};
export const AsyncExecutorPoolProvider = ({
  children
}) => {
  const executorRef = useRef({});
  return /*#__PURE__*/React.createElement(AsyncExecutorPoolContext.Provider, {
    value: {
      getExecutor: key => {
        return executorRef.current[key];
      },
      addExecutor: (key, executor) => {
        executorRef.current[key] = executor;
      }
    }
  }, children);
};